import React       from 'react';
import ReactDom    from 'react-dom';
// -------------------------------------------------------

class InputTextarea extends React.Component {
  update() {
    this.props.update_ev.bind(this)(this.item.value);
  }
  
  setTemplate() {
    let data = this.props.data;
    
    if( this.item.value != '' ){
      let chk = confirm('設定中のデータを上書きしてテンプレートを反映します。よろしいですか？');
      if( chk == false ) return;
    }
    this.item.value = data.template;
    this.props.update_ev.bind(this)(data.template);
  }
  
  render() {
    let data = this.props.data;
    
    return (
      <div className="textarea">
        { (data.template != undefined) && <p className="template-button" onClick={this.setTemplate.bind(this)}>テンプレート反映</p> }
        <textarea className="text" ref={(input) => { this.item = input }} onChange={this.update.bind(this)} defaultValue={data.default} placeholder={data.name +'を入力してください'} />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InputTextarea;